import { render, staticRenderFns } from "./linkAccountPage.vue?vue&type=template&id=12115dd0&scoped=true"
import script from "./linkAccountPage.vue?vue&type=script&lang=ts"
export * from "./linkAccountPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12115dd0",
  null
  
)

export default component.exports